import { Component, OnInit } from '@angular/core';
import { AuthService } from '../shared/auth.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  currentYear: number;
  dropdownOpen: boolean = false;
  constructor(public _authService:AuthService) { }

  ngOnInit(): void {
    this.currentYear = new Date().getFullYear();
    ////console.log(this._authService.NIBNumber);
  }
  

}
